import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';

interface INoDataOverlayProps {
	messageId: string;
}

const NoDataOverlay: React.FC<INoDataOverlayProps> = ({ messageId }) => (
	<Stack height="100%" alignItems="center" justifyContent="center">
		<Typography variant="overline" color="text.disabled">
			{intl.tr(messageId)}
		</Typography>
	</Stack>
);

export default NoDataOverlay;
